var parent = require('../../actual/object/get-prototype-of');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/full/object/get-prototype-of.js
// module id = 4341
// module chunks = 25